import React from "react";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Icon } from "@iconify/react";


const Favorite = ({ reacts }) => {

  const handleClick = () => {

  };

  const tip = reacts?.map(react => react.users[0].firstName + " " + react.users[0].lastName).join("\n");

  return (
    <Tooltip title={
      <div style={{ whiteSpace: "pre-line" }}>{tip}</div>
    }>
      <Chip
        onClick={handleClick}
        size="small"
        sx={{
          background: "white",
          height: "20px",
          "& .MuiChip-label": { px: "6px" },
          "&:hover": {
            background: "white",
          }
        }}
        label={
          <Stack
            direction="row"
            spacing={0.5}
            justifyContent="center"
            alignItems="center"
          >
            <Icon
              icon="ant-design:heart-filled"
              className="!text-[13px] text-pink-500"
            />
            <Typography sx={{ fontSize: "11px", fontWeight: "bold", color: "#1A73E8" }}>{reacts?.length}</Typography>
          </Stack>
        }
      />
    </Tooltip>
  );
};

export default Favorite;
